import { LpPage } from 'components/pages/lp'
import { publicEnv } from 'env'
import { NextPage } from 'next'
import { NextSeo } from 'next-seo'
import { Routes } from 'routes'

const Page: NextPage = () => {
  return (
    <>
      <NextSeo title={'HoteCo｜国内・海外ホテル予約サービス'} openGraph={{ url: `${publicEnv.host}${Routes.lp()}` }} />
      <LpPage />
    </>
  )
}

export default Page
